/* @flow */
import React, { Component } from 'react'

import './ShareButtons.css'

type Props = {
  size: ?string,
}

export default class ShareButtons extends Component<Props> {

  static defaultProps = {
    size: 'large'
  }

  url = () => {
		return "https://www.novoprotocol.com"
	}

	content = () => {
		return "@NovoProtocol: Business identity & credibility on the blockchain"
	}

	tweetText = () => {
		const truncatedTitle = this.content().length > 85 ? this.content().substring(0,85) + '...' : this.content()
		return truncatedTitle
	}

	twitterUrl = () => {
		return "https://twitter.com/intent/tweet?" +
           "text=" + encodeURIComponent(this.tweetText()) +
           "&url=" + this.url()
	}

	facebookUrl = () => {
		return "https://www.facebook.com/sharer.php?&u=" + this.url()
	}

  linkedinUrl = () => {
		return "https://www.linkedin.com/shareArticle?" +
           "&original_referer=" + encodeURIComponent(this.url()) +
           "&url=" + encodeURIComponent(this.url())
	}

	emailUrl = () => {
		const text = "Hey, have you seen Novo Protocol? They're bringing business identity and credibility to the blockchain. %0A%0A " + this.url()

		var subject = encodeURIComponent("Business credibility on the blockchain");
		return "mailto:?body=" + text + "&subject=" + subject;
	}

  render() {
    return (
      <div className='ShareButtons'>
        {this.props.size !== "large" &&
          <div className="ShareButtons--share-text">SHARE</div>
        }
        <a className={this.props.size === "large" ? "button button-twitter" : "button button-twitter button-small"} href={this.twitterUrl()} target="_blank">
          <i className='icon icon-twitter' /> <span className="icon-button--text">{this.props.size === "large" ? "Share on Twitter" : "TWITTER"}</span>
        </a>
        <a className={this.props.size === "large" ? "button button-linkedin" : "button button-linkedin button-small"}  href={this.linkedinUrl()} target="_blank">
          <i className='icon icon-linkedin-in' /> <span className="icon-button--text">{this.props.size === "large" ? "Share on Linkedin" : "LINKEDIN"}</span>
        </a>
        <a className={this.props.size === "large" ? "button button-email" : "button button-email button-small"}  href={this.emailUrl()}>
          <i className='icon icon-envelope' /> <span className="icon-button--text">{this.props.size === "large" ? "Share via email" : "EMAIL"}</span>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/ShareButtons/ShareButtons.js